import angular from 'angular';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import {normalizeTimeframe} from '../../common/datetime/date-ranges';
import template from './analyticsExploreAxisSettings.jade';

export class AnalyticsExploreAxisSettingsController {
  /* @ngInject */
  constructor($stateParams, $filter) {
    this.$stateParams = $stateParams;
    this.$filter = $filter;

    this.typeOptions = [
      {value: 'spline', icon: 'icon-chart-line:modal'},
      {value: 'column', icon: 'icon-chart-bar:modal'},
      {value: 'area',   icon: 'icon-chart-area:modal'}
    ];

    if (this.axisIndex == 0) {
      this.series.push(this.serieByMetric(this.$stateParams.axisName));
      this.serieChange.onNext(this.series[this.axisIndex]);
    }
  }

  serieByMetric(metric) {
    return _.clone(this.seriesOptions[metric]);
  }

  updateSerieMetric(metric) {
    if (this.axisIndex == this.series.length) {
      this.series.push(this.serieByMetric(metric));
    } else {
      this.series[this.axisIndex] = this.serieByMetric(metric);
    }
    this.serieChange.onNext(this.series[this.axisIndex]);
  }

  updateSerieType(type) {
    if (this.axisIndex > this.series.length-1)
      return;

    this.series[this.axisIndex].type = type;
    this.serieChange.onNext(this.series[this.axisIndex]);
  }

  metricTranslateKey(metric) {
    return ['$analytics', 'game', metric, 'label'].join('.');
  }
}

export function AnalyticsExploreAxisSettingsComponent() {
  return {
    template,
    controller: AnalyticsExploreAxisSettingsController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      series: '=',
      seriesOptions: '=',
      serieChange: '=',
      axisIndex: '=',
      onChange: '&'
    },
    bindToController: true
  };
};

export default angular.module('app.components.analytics.explore.axisSettings', [
  ServicesModule.name,
  ResourcesModule.name
])
  .directive('analyticsExploreAxisSettings', AnalyticsExploreAxisSettingsComponent);



/** WEBPACK FOOTER **
 ** ./src/components/analytics/analyticsExploreAxisSettings.js
 **/